import { Helmet } from "react-helmet-async";

import Hero from "../components/Hero";
import FeaturedHotels from "../components/FeaturedHotels";
import PopularDestinations from "../components/PopularDestinations";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import TrustedPartners from "../components/TrustedPartners";

export default function Home() {
    return (
        <>
            <Helmet>
                {/* Basic SEO */}
                <title>UAE Discounted Hotels | Best Hotel Deals & Affordable Stays in UAE</title>

                <meta
                    name="description"
                    content="Find the best discounted hotels across Dubai, Abu Dhabi, Sharjah, Ras Al Khaimah, Ajman, Fujairah, and the UAE. Compare prices and book affordable luxury and budget hotels with UAE Discounted Hotels."
                />

                <meta
                    name="keywords"
                    content="UAE hotels, discounted hotels UAE, Dubai hotels, Abu Dhabi hotels, hotel booking UAE, cheap hotels Dubai, luxury hotels UAE, budget hotels UAE, hotel deals UAE"
                />

                <meta name="robots" content="index, follow" />
                <meta name="author" content="UAE Discounted Hotels" />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://uaediscountedhotels.com/"
                />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="UAE Discounted Hotels" />
                <meta property="og:locale" content="en_US" />

                <meta
                    property="og:title"
                    content="UAE Discounted Hotels | Best Hotel Deals & Affordable Stays in UAE"
                />

                <meta
                    property="og:description"
                    content="Book discounted hotels across Dubai, Abu Dhabi, Sharjah, and the UAE with exclusive deals and affordable prices."
                />

                <meta
                    property="og:url"
                    content="https://uaediscountedhotels.com/"
                />

                <meta
                    property="og:image"
                    content="https://uaediscountedhotels.com/images/default-og.png"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="UAE Discounted Hotels | Best Hotel Deals & Affordable Stays in UAE"
                />

                <meta
                    name="twitter:description"
                    content="Find exclusive hotel deals and book affordable hotels across the UAE."
                />

                <meta
                    name="twitter:image"
                    content="https://uaediscountedhotels.com/images/default-og.png"
                />
            </Helmet>

            <div className="bg-gray-50 dark:bg-gray-950 min-h-screen">
                <Hero />
                <FeaturedHotels limit={8} />
                <PopularDestinations />
                <WhyChooseUs />
                <Testimonials />
                <TrustedPartners />
            </div>
        </>
    );
}